// Auto-generated by run-splitter script
// This file contains configuration constants for the GeoJSON batch loading system

export const BATCH_COUNT = 50;
export const BATCH_FILE_PREFIX = 'alexandria_parcels_batch_';
export const BATCH_FILE_SUFFIX = '.geojson.gz';
export const DATA_DIRECTORY =
  (import.meta.env.VITE_API_BASE_URL || '/data/').replace(/\/$/, '') + '/';

// Helper function to generate batch file path
export const getBatchFilePath = (batchNumber: number): string => {
  const paddedNumber = String(batchNumber).padStart(3, '0');
  return `${DATA_DIRECTORY}${BATCH_FILE_PREFIX}${paddedNumber}${BATCH_FILE_SUFFIX}`;
};

// Helper function to get all batch file paths
export const getAllBatchFilePaths = (): string[] => {
  return Array.from({ length: BATCH_COUNT }, (_, i) => getBatchFilePath(i + 1));
};
